<template>
  <main class="admin-page">
    <header class="page-heading"><div><div class="page-kicker">FINANCE LEDGER</div><h1 class="page-title">资金流水</h1><p class="page-lead">记录支付、退款、结算与提现；免费运营阶段的平台服务费应保持为零。</p></div><el-button icon="el-icon-refresh" @click="load">刷新</el-button></header>
    <section class="surface"><el-table :data="list" empty-text="暂无资金流水">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="order_id" label="订单ID" width="90" />
      <el-table-column prop="type" label="类型" width="120" />
      <el-table-column prop="amount" label="订单金额" width="120" />
      <el-table-column prop="commission_amount" label="平台服务费" width="120" />
      <el-table-column prop="creator_amount" label="婚影师收入" width="130" />
      <el-table-column prop="status" label="状态" width="100" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="created_at" label="时间" width="180" />
    </el-table></section>
  </main>
</template>

<script>
import request from '../api/request'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'

export default {
  components: { ElTable, ElTableColumn },
  data() {
    return { list: [] }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      const res = await request.get('/transactions')
      this.list = res.list
    }
  }
}
</script>
